var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.314,
    height: 93.6,
    viewBox: "0 0 91.314 93.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13007",
    "data-name": "Group 13007",
    transform: "translate(0.5 0.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11134",
    "data-name": "Path 11134",
    d: "M1592.792,711.209a20.257,20.257,0,0,0,15.241-11.149c3.964-7.952,5.685-32.506,13.358-32.878,13.091-.651,13,26.821,8.719,34.7,3.581.186,26.845,1.012,28.275,1.616.209-.442,6.045,3.569,5.882,8.847-.093,3.3-2.557,5.952-4.778,7.7a10.759,10.759,0,0,1,2.813,4.987c1.291,4.627-2.464,7.6-5.476,9.2a11.229,11.229,0,0,1,1.744,3.976c.674,3.244-2.627,5.987-5.231,7.615a12.7,12.7,0,0,1,1.732,4.592c1.092,6.115-5.232,9.1-5.255,9.115a2.4,2.4,0,0,1-1.257.232l-47.643-1.7a2.382,2.382,0,0,1-1.209-.372l-8.021-5.212a2.439,2.439,0,0,1-1.127-2.163l0-36.675A2.425,2.425,0,0,1,1592.792,711.209Z",
    transform: "translate(-1573.958 -667.171)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5178",
    "data-name": "Rectangle 5178",
    width: 16.602,
    height: 40.214,
    transform: "translate(0 44.608)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8f7da054a8aed0f24369dd91434acd83.svg";
export { ForwardRef as ReactComponent };